var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuex-table',{attrs:{"table_store":"pbx/time-conditions/table","fields":_vm.fields,"table_class":['table--content-middle']},scopedSlots:_vm._u([{key:"name",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'pbx.time-condition.edit', params: { id: item.id } }}},[_vm._v(" "+_vm._s(item.name)+" ")])]}},{key:"worktimes",fn:function(ref){
var item = ref.item;
return [_c('work-time-list-collapse',{attrs:{"items":item.worktimes}})]}},{key:"actions",fn:function(ref){
var item = ref.item;
return [_c('table-control',{attrs:{"type":"trash"},on:{"click":function($event){return _vm.remove_item(item)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }